import React, {useEffect} from "react";
import Styles from './styles.module.scss';

import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {checkAcademy} from "../../store/cabinet/action";
import {useNavigate} from "react-router-dom";

const AcademyWarning = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const checkAcademyStatusStarted = useSelector(store => store.cabinet.checkAcademyStatusStarted);


    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Добро пожаловать на OMT Launchpad')}!</div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Launchpad доступен только для квалифицированных участников')}</div>
                <div className={`${Styles.contentWrapNote}`}>{t('Для работы с Launchpad необходимо пройти обучение в OMT Academy и получить квалификацию')}.</div>
                <div className={`${Styles.btnWrap}`}>
                    <a className={`${Styles.btn}`} href="https://honee.technology/academy">{t('Купить OMT Academy')}</a>
                    <div
                        className={`${Styles.btn} ${checkAcademyStatusStarted ? Styles.btnDsb : null}`}
                        onClick={()=>{
                            if (!checkAcademyStatusStarted) {
                                dispatch(checkAcademy());
                            }
                        }}
                    >
                        {t('Я уже купил')}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademyWarning;
